export function isPdfFile(file: File | null | undefined): boolean {
  if (!file) return false;
  return file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
}

export function getPdfFiles(files: readonly File[]): File[] {
  return files.filter(isPdfFile);
}

/** Hides the browser PDF viewer sidebar/outline so the document uses full panel width. */
export function buildPdfPreviewEmbedUrl(blobUrl: string): string {
  return `${blobUrl}#navpanes=0&pagemode=none&view=FitH`;
}

export function pdfFileKey(file: File, index: number): string {
  return `${file.name}-${file.lastModified}-${file.size}-${index}`;
}
